const config = {
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL,
    apiKey: process.env.REACT_APP_SUPABASE_API_KEY,
  },
};

export default config;
